import { BookCover, BookCoverProps, Col } from '@farol-ds/react'
import classNames from 'classnames'
import { Children, cloneElement, HTMLAttributes, isValidElement } from 'react'

import styles from './appbar-start.module.scss'

export type AppBarStartElement = HTMLDivElement

export type AppBarStartProps = HTMLAttributes<AppBarStartElement>

function AppBarStart(props: AppBarStartProps) {
  const { children, className, ...rest } = props
  const classes = classNames(styles.root, className)
  return (
    <Col xs={12} md={6} lg={7}>
      <div {...rest} className={classes} data-fds-appbar-start>
        {renderChildren(children)}
      </div>
    </Col>
  )
}

function renderChildren(children: React.ReactNode) {
  return Children.map(children, (child) => {
    if (isValidElement(child)) {
      switch (child.type) {
        case BookCover:
          return cloneElement(child, {
            size: 'xs',
            className: classNames(styles.bookCover, child.props.className),
          } as BookCoverProps)
      }
    }
    return child
  })
}

export default AppBarStart
